import { render, staticRenderFns } from "./TaskFeature.vue?vue&type=template&id=940ce694&scoped=true&"
import script from "./TaskFeature.vue?vue&type=script&lang=js&"
export * from "./TaskFeature.vue?vue&type=script&lang=js&"
import style0 from "./TaskFeature.vue?vue&type=style&index=0&id=940ce694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940ce694",
  null
  
)

export default component.exports